import { createSlice } from "@reduxjs/toolkit";

/**
 * Fungsi hanya increment saja untuk trigger use effect agar reload data
 * Listener FCM hanya ada 1 di index dashboard, agar tidak ribet passing data, pakai redux
 */

export const queueUpdate = createSlice({
  name: "queue_update",
  initialState: {
    value: 0,
  },
  reducers: {
    updateQueue: (state) => {
      state.value += 1;
    },
  },
});

export const { updateQueue } = queueUpdate.actions;

export default queueUpdate.reducer;
